import { ActionTree } from 'vuex';
import { Course, CourseState } from './state';
import RootState from '@/store/root_state';
import { MicroserviceEnum, query } from '@/helpers/westeros';
import { allCourses, AllCoursesQueryResult } from '@/store/graphql/queries/westerosQueries';
import i18n from '@/i18n';
import { UpsertAdmissionMutationInput } from '@/store/graphql/mutations/westerosMutations';

const actions: ActionTree<CourseState, RootState> = {
  async UPDATE_COURSE({ dispatch }, payload: { course: Course }): Promise<void> {
    const { course } = payload;

    const params: UpsertAdmissionMutationInput = { courseId: course.id };

    await dispatch('UPSERT_ADMISSION', params);
  },

  async PULL_AVAILABLE_COURSES({ commit }): Promise<void> {
    const { data } = await query<AllCoursesQueryResult>(
      MicroserviceEnum.ADMISSIONS,
      allCourses,
      { isAvailable: true },
      true,
    );

    const courses: Course[] = data.allCourses.map(({ id, name, courseType, durationYears }) => ({
      id,
      name,
      type: courseType,
      duration: `${durationYears.toLocaleString()} ${i18n.tc('yearOfDuration', durationYears)}`,
    }));

    commit(
      'SET_AVAILABLE_COURSES',
      courses.sort(({ name: name1 = '' }, { name: name2 = '' }) => name1.localeCompare(name2)),
    );
  },
};

export default actions;
